export default "__VITE_ASSET__BHwLhShz__"